import React from 'react';
import { Box, IconButton, useTheme } from '@mui/material';
import { Menu as MenuIcon } from 'lucide-react';
import { LAYOUT } from '../../../constants/layout';

interface MenuHeaderProps {
  isDrawerOpen: boolean;
  onMenuClick: () => void;
  toolbarHeight?: number;
}

const MenuHeader: React.FC<MenuHeaderProps> = ({
  onMenuClick,
  toolbarHeight = LAYOUT.TOOLBAR_HEIGHT,
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        width: '64px',
        height: toolbarHeight,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderBottom: `1px solid ${theme.palette.divider}`,
        backgroundColor: theme.palette.background.paper,
        flexShrink: 0,
      }}
    >
      <IconButton
        onClick={onMenuClick}
        sx={{
          color: theme.palette.text.primary,
          borderRadius: '8px',
          '&:hover': {
            backgroundColor: theme.palette.action.hover,
          },
        }}
      >
        <MenuIcon size={20} />
      </IconButton>
    </Box>
  );
};

export default MenuHeader;
